import { render } from "./Statsbanner.vue?vue&type=template&id=a4fcf1e4&scoped=true"
import script from "./Statsbanner.vue?vue&type=script&lang=js"
export * from "./Statsbanner.vue?vue&type=script&lang=js"

import "./Statsbanner.vue?vue&type=style&index=0&id=a4fcf1e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4fcf1e4"]])

export default __exports__